// Copyright (c) 2016 Deere & Company

import './new-transfer-body.scss';
import React, {PropTypes} from 'react';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import {FormattedMessage} from 'react-intl';
import Modal from '../../shared/state/modal';
import NewTransferButtonGroup from './new-transfer-button-group';
import NewTransferDealer from './new-transfer-dealer';
import Transfer from '@deere/cps-it.warranty-model-factory/lib/transfer';

const NewTransferBody = props => {

    const disableTransfer = props.newTransfer.newDealer.account === '' || props.newTransfer.reasonForChange === '';

    const transferClassName = `button-primary ${disableTransfer ? 'disable-button' : 'enable-button'}`;

    return (
        <section className='new-transfer-body'>
            <div className='new-transfer-body-panel'>
                <div className='dealer-details'>
                    <NewTransferDealer
                        accountLookup={props.accountLookup}
                        dealer={props.dealer}
                        isRequired={false}
                        label='CURRENT_DEALER_LOCATION'
                        onAccountLookupBlur={props.onAccountLookupBlur}
                        onAccountLookupChange={props.onAccountLookupChange}
                        onResetClick={props.onResetClick}
                    />
                    <NewTransferDealer
                        accountLookup={props.accountLookup}
                        dealer={props.newTransfer.newDealer}
                        dealerSearchModal={props.dealerSearchModal}
                        icon={true}
                        isRequired={true}
                        label='NEW_DEALER_LOCATION'
                        onAccountLookupBlur={props.onAccountLookupBlur}
                        onAccountLookupChange={props.onAccountLookupChange}
                        onDealerSearchViewClick={props.onDealerSearchViewClick}
                        onResetClick={props.onResetClick}
                    />
                    <NewTransferButtonGroup
                        disableTransfer={disableTransfer}
                        onCancelClick={props.onCancelClick}
                        onCreateTransferClick={props.onCreateTransferClick}
                        onResetClick={props.onResetClick}
                        transferClassName={transferClassName}
                    />
                </div>
                <div className='reason-for-transfer'>
                    <div className='reason-for-transfer-label asterisk-after'>
                        <FormattedMessage id='REASON_FOR_TRANSFER'/>
                    </div>
                    <input
                        maxLength='119'
                        onChange={props.onReasonForChangeInputChange}
                        type='text'
                        value={props.newTransfer.reasonForChange}
                    />
                </div>
                <div className='required-asterisk-symbol'>
                    <FormattedMessage id='INDICATES_REQUIRED_FIELD'/>
                </div>
            </div>
        </section>
    );

};

NewTransferBody.displayName = 'NewTransferBody';
NewTransferBody.propTypes = {
    accountLookup: PropTypes.string.isRequired,
    dealer: PropTypes.instanceOf(Dealer).isRequired,
    dealerSearchModal: PropTypes.instanceOf(Modal).isRequired,
    newTransfer: PropTypes.instanceOf(Transfer).isRequired,
    onAccountLookupBlur: PropTypes.func.isRequired,
    onAccountLookupChange: PropTypes.func.isRequired,
    onCancelClick: PropTypes.func.isRequired,
    onCreateTransferClick: PropTypes.func.isRequired,
    onDealerSearchViewClick: PropTypes.func.isRequired,
    onReasonForChangeInputChange: PropTypes.func.isRequired,
    onResetClick: PropTypes.func.isRequired
};

export default NewTransferBody;



// WEBPACK FOOTER //
// ./src/product/new-transfer/components/new-transfer-body.js